import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KALA } from '@store/models';
import { NotificationsDispatchers, NotificationsService } from '../../../store';
import { NavigationService } from '../../../core/navigation.service';

@Component({
    selector: 'app-ka-la',
    template: `
        <app-ka-la-ui
            [kalas]="kalas$ | async"
            (gotoSag)="gotoSag($event)"
            (dismiss)="dismiss()"
        ></app-ka-la-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KALAContainer {
    kalas$ = this.notificationsService.getKALA();

    constructor(
        public activeModal: NgbActiveModal,
        private notificationsService: NotificationsService,
        public notificationsDispatchers: NotificationsDispatchers,
        private navigationService: NavigationService
    ) {}

    async gotoSag(client: KALA) {
        this.notificationsDispatchers.navigateToClient(client.kid);
        this.activeModal.close();
        await this.navigationService.openCase(client.kid?.toString(), client.pid?.toString(), client.v2RegnskabsaarKundeId, client.yid);
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
